import styled from '@emotion/styled'

export const TopTabsWrapper = styled.div`
  margin: 10px 0;
`
